import { render, staticRenderFns } from "./PermissionGrantPage.vue?vue&type=template&id=3786e389&"
import script from "./PermissionGrantPage.vue?vue&type=script&lang=ts&"
export * from "./PermissionGrantPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports